import { createHash } from "node:crypto";

import type { BoardState } from "../model/position.js";

export function canonicalStateJson(state: BoardState) {
  const atoms = Object.values(state.atoms)
    .sort((left, right) => left.id.localeCompare(right.id))
    .map((atom) => ({
      ...atom,
      tags: [...atom.tags].sort(),
    }));

  const cells = Object.values(state.cells)
    .sort((left, right) => left.id.localeCompare(right.id))
    .map((cell) => ({ ...cell }));

  return JSON.stringify({
    atoms,
    cells,
    line: state.line,
  });
}

export function computeStateHash(state: BoardState) {
  return createHash("sha256").update(canonicalStateJson(state)).digest("hex").slice(0, 16);
}
